export default "__VITE_ASSET__DP7Spdf3__"